import React, { useEffect, useState } from 'react'
import classnames from "classnames";
import { Button, ButtonGroup, Card, CardBody, CardHeader, CardImg, Col, Row, Table,
    NavItem, NavLink, Nav, TabContent, TabPane } from 'reactstrap'

function NavVehiculoParticulas(props) {
    const {Tabs, setTabs} = props;
    return (
        <Card style={{width:"100%"}}>
            <CardBody>
                <div className="nav-wrapper">
                    <Nav
                        className="nav-fill flex-column flex-md-row"
                        id="tabs-icons-text"
                        pills
                        role="tablist"
                        style={{width:"100%"}}
                    >
                        <NavItem>
                        <NavLink
                            aria-selected={Tabs === 1}
                            className={classnames("mb-sm-3 mb-md-0", {
                            active: Tabs === 1
                            })}
                            onClick={e => setTabs(1)}
                            role="tab"
                        >
                            Arreglos Mecanicos
                        </NavLink>
                        </NavItem>
                        <NavItem>
                        <NavLink
                            aria-selected={Tabs === 2}
                            className={classnames("mb-sm-3 mb-md-0", {
                            active: Tabs === 2
                            })}
                            onClick={e => setTabs(2)}
                            role="tab"
                        >
                            Observaciones
                        </NavLink>
                        </NavItem>
                    </Nav>
                    </div>
            </CardBody>
        </Card>
    );
}

export default NavVehiculoParticulas;